import React from 'react';
import { motion } from 'framer-motion';
import { Section, staggerContainer, fadeIn } from './ui/Section';
import { Smartphone, Book, List, GraduationCap } from 'lucide-react';
export function WhyFailsSection() {
  const reasons = [{
    icon: Smartphone,
    title: 'Apps',
    desc: 'Te entrenan a tocar botones, no a sostener conversaciones reales.'
  }, {
    icon: GraduationCap,
    title: 'Gramática primero',
    desc: 'Te obliga a pensar reglas en el peor momento: cuando tienes que hablar.'
  }, {
    icon: List,
    title: 'Listas de vocabulario',
    desc: 'Sabes palabras sueltas, pero no tienes frases completas listas para usar.'
  }, {
    icon: Book,
    title: 'Inglés de libro',
    desc: 'No coincide con el tono real de la calle en USA. Suenas a robot.'
  }];
  return <Section className="bg-slate-50" data-id="element-294">
      <div className="text-center mb-16" data-id="element-295">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-296">
          Por qué lo que probaste falla
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-297">
          No es tu culpa. Los métodos tradicionales no están diseñados para la
          reacción rápida.
        </p>
      </div>

      <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-298">
        {reasons.map((reason, idx) => <motion.div key={idx} variants={fadeIn} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-299">
            <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mb-4 text-slate-700" data-id="element-300">
              <reason.icon className="w-6 h-6" data-id="element-301" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-302">
              {reason.title}
            </h3>
            <p className="text-slate-600 text-sm leading-relaxed" data-id="element-303">
              {reason.desc}
            </p>
          </motion.div>)}
      </motion.div>
    </Section>;
}